import axios from 'axios'

// This is the base class from which each services has to inherit.
export interface IBaseService<T> {
  get(): Promise<T[]>
  create(data: T): Promise<T>
  update(data: T): Promise<T>
  delete(id: number | string): Promise<number>
}

export default abstract class BaseService<T> implements IBaseService<T> {
  protected static readonly authorizationHeader = 'Authorization'
  protected readonly instance = axios

  protected resourcePath: string

  constructor(resoursePath: string) {
    this.resourcePath = resoursePath
  }

  public setToken(token: string) {
    if (token) {
      axios.defaults.headers.common[BaseService.authorizationHeader] =
        'Bearer ' + token
    }
  }

  public async get(): Promise<T[]> {
    const result = await axios.get<T[]>(this.resourcePath)
    return result.data
  }

  public async create(data: T): Promise<T> {
    const result = await axios.post<T>(this.resourcePath, data)
    return result.data
  }

  public async update(data: T, id?: string | number | undefined): Promise<T> {
    const path =
      id !== undefined ? this.resourcePath + id + '/' : this.resourcePath
    const result = await axios.put<T>(path, data)
    return result.data
  }

  public async delete(id: number | string): Promise<number> {
    const result = await axios.delete(this.resourcePath + id + '/')
    return result.status
  }
}
